import React from 'react';
import { string, number, shape, bool, oneOf } from 'prop-types';
import { progressUnionTypes, getHumanisedNumber } from '@paddl/utils-js';
import Truncate from 'react-truncate';
import { ProgressSectionRead } from '../../../..';
import { BigActivityTimelineCardContentWrapper, BadgeWrapper, Title, Subtitle, Content, TopContent, BottomContent, XpNumber, Skills, ProgressSectionWrapper } from './BigActivityTimelineCardContent.styles';
import { renderBadge } from '../../../../Utils/renderBadge';
export const BigActivityTimelineCardContent = _ref => {
  let {
    title,
    type,
    progressType,
    subtitle,
    xpNumber,
    skills,
    percentageComplete,
    duration
  } = _ref;
  return /*#__PURE__*/React.createElement(BigActivityTimelineCardContentWrapper, null, /*#__PURE__*/React.createElement(BadgeWrapper, null, renderBadge(type)), /*#__PURE__*/React.createElement(Content, {
    "data-testid": "big-card-content"
  }, /*#__PURE__*/React.createElement(TopContent, null, /*#__PURE__*/React.createElement(Title, null, /*#__PURE__*/React.createElement(Truncate, null, title)), xpNumber > 0 && /*#__PURE__*/React.createElement(XpNumber, {
    type: type
  }, /*#__PURE__*/React.createElement("span", null, getHumanisedNumber(xpNumber)), /*#__PURE__*/React.createElement("small", null, "XP"))), /*#__PURE__*/React.createElement(BottomContent, null, /*#__PURE__*/React.createElement(Subtitle, null, /*#__PURE__*/React.createElement(Truncate, null, subtitle)), /*#__PURE__*/React.createElement(Skills, null, /*#__PURE__*/React.createElement("span", null, skills), /*#__PURE__*/React.createElement("span", null, "Skills"))), /*#__PURE__*/React.createElement(ProgressSectionWrapper, null, /*#__PURE__*/React.createElement(ProgressSectionRead, {
    layout: "OneLineSmallProgress",
    progressType: progressType,
    data: {
      percentageComplete,
      duration
    }
  }))));
};
BigActivityTimelineCardContent.propTypes = {
  title: string,
  type: string,
  progressType: oneOf(progressUnionTypes).isRequired,
  subtitle: string,
  xpNumber: number,
  skills: number,
  percentageComplete: number,
  duration: shape({
    startDate: shape({
      day: number,
      month: number,
      year: number
    }),
    endDate: shape({
      day: number,
      month: number,
      year: number
    }),
    timeStamp: shape({
      day: number,
      month: number,
      year: number
    }),
    isCurrent: bool
  }).isRequired
};
BigActivityTimelineCardContent.defaultProps = {
  type: undefined,
  title: '',
  subtitle: '',
  xpNumber: undefined,
  skills: 1,
  percentageComplete: null
};